export default "__VITE_ASSET__B0_q1j5f__"